import { ReactElement } from 'react';
import { TimeCodeText, TimeCodeButton } from './Transcription.style';
import { parseTimeCode } from './parseTimeCode';

interface Props {
  timeCode: string;
  /** 音声を再生できない場合は null。null のとき、time_code をクリックできない文字列として表示する */
  onClick: ((seconds: number) => void) | null;
}

const TimeCode = ({ timeCode, onClick }: Props): ReactElement => {
  const seconds = parseTimeCode(timeCode);
  // 形式が壊れた time_code も、移動先を決められないため文字列のまま表示する
  if (onClick === null || seconds === null) {
    return <TimeCodeText>{timeCode}</TimeCodeText>;
  }
  const handleClick = (): void => {
    onClick(seconds);
  };
  return (
    <TimeCodeButton type='link' size='small' aria-label={`再生位置を ${timeCode} へ移す`} onClick={handleClick}>
      {timeCode}
    </TimeCodeButton>
  );
};

export default TimeCode;
